import { useRef, useState, useEffect } from "react";

const Accordion = ({
  isExpanded,
  animationDuration = 300,
  skipInitialAnimation,
  children,
  className,
  style,
  ...props
}) => {
  const ref = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    }

    if (ref.current) {
      setContentHeight(ref.current.clientHeight);
    }
  }, [children]);

  const s = {
    height: isExpanded ? (skipInitialAnimation && firstRender.current ? "auto" : contentHeight) : 0,
    transitionDuration:
      skipInitialAnimation && firstRender.current ? undefined : `${animationDuration}ms`,
    ...style,
  };

  return (
    <div className={`accordion ${className}`} style={s} {...props}>
      <div ref={ref}>{children}</div>
    </div>
  );
};

export default Accordion;
